import { Paragraph, Table } from 'docx';
import { EsrsReportMetric } from '../../Report.types';
import { simplifyNarrativeMetrics } from '../../Report.hooks';
import { QuestionType_Enum_ } from 'models';
import { addEmptySpace } from '../report-helper-functions';
import { createQuantitativeMetrics } from './quantitative-metrics';
import { createGOV4Table } from '../CustomTables/gov4-table';
import { GOV_4Metrics } from '../../ReportComponents';
import { createNarrativeMetric } from './narrative-metrics';

export const createMetrics = (
  metrics: EsrsReportMetric[],
  companyCurrency: string
): (Paragraph | Table)[] => {
  const visibleMetrics = metrics.filter((metric) => !metric.metric.isHidden);

  // Use unique refs to avoid displaying the same metric twice
  const uniqueRowRefs: string[] = [];

  const simplifiedMetrics = simplifyNarrativeMetrics(metrics);

  const combinedMetricsSection = visibleMetrics.flatMap((metric) => {
    const isQuantitative =
      metric.metric.metric.metricType === QuestionType_Enum_.Decimal_ &&
      metric.metric.metric.isAssessable === true &&
      !metric.metric.metric.parentMetrics.some(
        (pm) => pm.parentMetric.metricType !== QuestionType_Enum_.Decimal_
      );

    if (isQuantitative) {
      return [createQuantitativeMetrics([metric], companyCurrency, uniqueRowRefs)];
    } else {
      // Narrative metrics
      if (
        metric.metric.metricRef ===
        'disclosureofmappingofinformationprovidedinsustainabilitystatementaboutduediligenceprocess'
      ) {
        return [
          [
            createGOV4Table(
              metrics.filter((m) => GOV_4Metrics.includes(m.metric.metricRef)) as EsrsReportMetric[]
            ),
          ],
          addEmptySpace(200),
        ];
      }

      const simplifiedMetric = simplifiedMetrics.find(
        (m) => m.materialMetric.metricRef === metric.metric.metricRef
      );
      if (!simplifiedMetric) {
        return [];
      }
      return [
        createNarrativeMetric(simplifiedMetric, true, metrics, companyCurrency, uniqueRowRefs),
        addEmptySpace(200),
      ];
    }
  });

  return combinedMetricsSection.flat();
};
